<template>
  <vs-popup class="add-new-pack-size"
            id="popup"
            :title="isCreateMode ? 'ADD PACK SIZE' : 'UPDATE PACK SIZE'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-pack-size-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="size" name="size" rules="required" v-slot="{ errors }">
                <small class="label">Size (KG)</small>
                <vs-input v-model="form.size"  name="size" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="form.description" height="150px"/>
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-ccp-items-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const PackSizeRepository = RepositoryFactory.get('pack_size');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: { name: '', size: '', description: '' },
      isCreateMode: true
    }
  }

  export default {
    name: 'AddNewPackSizePopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          if (!!id) {
            this.id = id
            this.isCreateMode = false
            await this.fetchPackSizeDetails()
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async fetchPackSizeDetails() {
        await this.$vs.loading({
          container: '#create-pack-size-popup',
          scale: 0.45
        })
        try {
          const {data} = (await PackSizeRepository.getPackSizeDetails(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-pack-size-popup > .con-vs-loading')
      },
      async onClickCreateSite() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-pack-size-popup',
          scale: 0.45
        })
        try {
          this.form.size = Number(this.form.size).toFixed(3)
          if (this.isCreateMode) {
            await PackSizeRepository.createPackSize(this.form);
            this.showSuccessMessage('Pack Size added!');
          } else {
            await PackSizeRepository.updatePackSize(this.id, this.form);
            this.showSuccessMessage('Pack Size updated!');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-pack-size-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-pack-size-popup > .con-vs-loading')
      },
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-pack-size >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
